import { Signal } from '@angular/core';
import { PaymentMethodResult } from '@stripe/stripe-js';
import { Observable } from 'rxjs';

export abstract class GusPaymentMethodForm<P = PaymentMethodResult> {
  abstract isValid: Signal<boolean>;

  abstract createMethod(): Observable<P>;

  abstract initializePaymentDetails(): void;
}
